<wuc-rack *ngIf="purchasedProduct" gridGap="medium">
    <wuc-display-field [hideAction]="true">
        <label>
            Einddatum
            <span
                *ngIf="purchasedProduct?.product?.endDate"
                insTooltip="Dit is de datum waarop u niet meer verzekerd bent"
            >
                <wuc-icon-ui icon="information"></wuc-icon-ui>
            </span>
        </label>
        <span class="ins-insurance-end-product-data__data-and-action">
            <span>
                {{ purchasedProduct?.product?.endDate ? (purchasedProduct?.product?.endDate | dateFormat) : "-" }}
            </span>
            <wuc-link *ngIf="canCancelAddedProduct" (clicked)="cancelAddedProduct()" type="secondary">
                <span>Verzekering annuleren</span>
            </wuc-link>
            <wuc-link *ngIf="canReviveProduct" (clicked)="reviveProduct()" type="secondary">
                <!-- prettier-ignore -->
                <span>
                    Toch niet opzeggen<wuc-icon-ui class="ins-insurance-end-product-data__action-icon" icon="cross-closed"></wuc-icon-ui>
                </span>
            </wuc-link>
            <panel-button
                *ngIf="canEndProduct"
                [target]="endProductForm"
                openText="Opzeggen"
                closeText="Sluiten"
            ></panel-button>
            <panel-button
                *ngIf="canAddEndDateProduct"
                [target]="endDateProductForm"
                openText="Verzekering eerder beëindigen"
                closeText="Sluiten"
            ></panel-button>
        </span>
    </wuc-display-field>
</wuc-rack>
